import { onPath } from '../utils/path';
import { selectOne, selectMany, addClass, removeClass, toggleClass, whenOlarkExists, scrollToSmooth } from '../utils/dom-utils';


onPath('/mobile-beta', () => {
  whenOlarkExists(function() {
    olark.configure("locale.chatting_title", "Let's chat about Mobile");
  });

  const olarkProCTA = selectMany('.mobile-cta');
  olarkProCTA.forEach(function (el, i) {
    el.href = "javascript:void(0)";
    el.addEventListener('click', function(e) {
      scrollToSmooth('instructions')
    });
  });





    var androidToggleButton = selectOne("#toggle-android-button");
    var appleToggleButton = selectOne("#toggle-apple-button");
    var androidToggleMethod = selectOne("#toggle-android-method");
    var appleToggleMethod = selectOne("#toggle-apple-method");


    androidToggleButton.addEventListener("click", function(e) {
      androidToggleButton.classList.add("mobilebeta-typetoggle-active");
      androidToggleButton.classList.remove("mobilebeta-typetoggle-inactive");

      appleToggleButton.classList.remove("mobilebeta-typetoggle-active");
      appleToggleButton.classList.add("mobilebeta-typetoggle-inactive");

      androidToggleMethod.classList.add('mobilebeta-small-active');
      androidToggleMethod.classList.remove('mobilebeta-small-inactive');

      appleToggleMethod.classList.remove('mobilebeta-small-active');
      appleToggleMethod.classList.add('mobilebeta-small-inactive');
    });

    appleToggleButton.addEventListener("click", function(e) {
      androidToggleButton.classList.remove("mobilebeta-typetoggle-active");
      androidToggleButton.classList.add("mobilebeta-typetoggle-inactive");

      appleToggleButton.classList.add("mobilebeta-typetoggle-active");
      appleToggleButton.classList.remove("mobilebeta-typetoggle-inactive");

      androidToggleMethod.classList.add('mobilebeta-small-inactive');
      androidToggleMethod.classList.remove('mobilebeta-small-active');

      appleToggleMethod.classList.add('mobilebeta-small-active');
      appleToggleMethod.classList.remove('mobilebeta-small-inactive');
    });



});

